<template>
  <div class="dup">
    <p class="dup-nota">
      <v-icon size="15" color="#8a939c">mdi-information-outline</v-icon>
      <span>Análise feita nos últimos {{ meta.janelaDias || 30 }} dias.</span>
    </p>

    <div v-if="items.length" class="dup-lista">
      <article v-for="g in items" :key="g.id" class="dup-grupo">
        <header class="dup-topo">
          <div class="dup-pessoas">
            <v-icon size="18" color="#6b747d"
              >mdi-account-multiple-outline</v-icon
            >
            <span v-for="(n, k) in g.passageiros" :key="k" class="dup-pessoa">{{
              n
            }}</span>
          </div>
          <div class="dup-resumo">
            <span class="dup-qtd">{{ g.vouchers.length }} reservas</span>
            <span v-if="g.canceladasRemovidas" class="dup-aviso">
              {{ g.canceladasRemovidas }}
              {{
                g.canceladasRemovidas > 1
                  ? "canceladas já retiradas"
                  : "cancelada já retirada"
              }}
            </span>
          </div>
        </header>

        <div class="dup-cards">
          <section v-for="v in g.vouchers" :key="v.voucher" class="dup-card">
            <div class="dup-card-topo">
              <span class="dup-voucher">{{ v.voucher }}</span>
            </div>

            <ul class="dup-servicos">
              <li v-for="(s, k) in v.servicos" :key="k" class="dup-servico">
                <span class="dup-bolinha"></span>
                <span class="dup-servico-txt" :title="s.descricao">{{
                  s.descricao || "(serviço sem descrição)"
                }}</span>
              </li>
              <li v-if="!v.servicos || !v.servicos.length" class="dup-servico">
                <span class="dup-servico-txt muted"
                  >Sem serviços informados</span
                >
              </li>
            </ul>

            <dl class="dup-dados">
              <div>
                <dt>Saída</dt>
                <dd>{{ v.saida || "—" }}</dd>
              </div>
              <div>
                <dt>Retorno</dt>
                <dd>{{ v.retorno || "—" }}</dd>
              </div>
              <div>
                <dt>Reserva</dt>
                <dd :class="{ 'dup-sem-reserva': semReserva(v.phoenix) }">
                  {{ codigoReserva(v.phoenix) }}
                </dd>
              </div>
              <div>
                <dt>Filial</dt>
                <dd>{{ v.filial || "—" }}</dd>
              </div>
            </dl>
          </section>
        </div>

        <footer class="dup-rodape">Última detecção: {{ g.ultimaVez }}</footer>
      </article>

      <p v-if="meta.listadas < meta.total" class="dup-mais">
        Listando {{ meta.listadas }} de {{ meta.total }} no período.
      </p>
    </div>

    <div v-else class="detail-empty detail-empty--ok">
      <v-icon size="18" color="#0f7a6e">mdi-check-circle-outline</v-icon>
      Nenhuma reserva nova com os mesmos passageiros de outra no período.
    </div>
  </div>
</template>

<script>
export default {
  name: "PossiveisDuplicadas",
  props: {
    items: { type: Array, default: () => [] },
    meta: {
      type: Object,
      default: () => ({ total: 0, listadas: 0, janelaDias: 30 }),
    },
  },
  methods: {
    // Codigo da reserva no PHOENIX (REC-xxxx, JPA-xxxx...) -- e' o que a equipe usa para escrever a
    // observacao ligando uma reserva a outra. null = o agente nao conseguiu consultar o Phoenix;
    // [] = ainda nao existe reserva (nao-PDV) desse voucher la.
    codigoReserva(p) {
      if (p == null) return "—";
      const codigos = [...new Set(p.map((r) => r && r.code).filter(Boolean))];
      return codigos.length ? codigos.join(", ") : "Sem reserva";
    },
    semReserva(p) {
      return Array.isArray(p) && !p.some((r) => r && r.code);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../_shared/detail.scss";

.dup-nota {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 12px;
  font-size: 0.8rem;
  color: #8a939c;
}

.dup-lista {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.dup-grupo {
  background: #fff;
  border: 1px solid #e6e9ec;
  border-radius: 12px;
  padding: 14px 16px 10px;
  box-shadow: 0 1px 2px rgba(20, 30, 40, 0.04);
}

.dup-topo {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 16px;
  margin-bottom: 12px;
}
.dup-pessoas {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
}
.dup-pessoa {
  font-size: 0.82rem;
  font-weight: 700;
  color: #2b333b;
  background: #f4f6f8;
  border: 1px solid #e6e9ec;
  border-radius: 20px;
  padding: 2px 11px;
}
.dup-resumo {
  display: flex;
  align-items: center;
  gap: 10px;
}
.dup-qtd {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6b747d;
}
.dup-aviso {
  font-size: 0.74rem;
  color: #7a5a00;
  background: #fff6dc;
  border-radius: 10px;
  padding: 1px 9px;
}

.dup-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 12px;
}

.dup-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #fafbfc;
  border: 1px solid #e6e9ec;
  border-radius: 10px;
  padding: 12px 14px;
}
.dup-card-topo {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 6px 10px;
}
.dup-voucher {
  font-size: 1rem;
  font-weight: 800;
  color: #2b333b;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
}
.dup-servicos {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.dup-servico {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.82rem;
  line-height: 1.35;
  color: #384049;
}
.dup-bolinha {
  flex: 0 0 6px;
  height: 6px;
  margin-top: 7px;
  border-radius: 50%;
  background: #b3bac1;
}
.dup-servico-txt {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.dup-dados {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
  padding-top: 10px;
  border-top: 1px dashed #dfe3e7;
  > div {
    min-width: 0;
  }
  dt {
    font-size: 0.64rem;
    font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #9aa2ab;
  }
  dd {
    margin: 1px 0 0;
    font-size: 0.8rem;
    font-weight: 600;
    color: #384049;
    font-variant-numeric: tabular-nums;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dup-sem-reserva {
  color: #9aa2ab !important;
  font-weight: 500 !important;
}

.dup-rodape {
  margin-top: 8px;
  font-size: 0.72rem;
  color: #9aa2ab;
  text-align: right;
}
.dup-mais {
  margin: 0;
  font-size: 0.78rem;
  color: #8a939c;
}

@media (max-width: 700px) {
  .dup-dados {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
